import Vue from "vue";

export const state = {
    type : null,
    message : null
}


export const  mutations = {
    success(state, message){
        Vue.$toast.success(message)
    },
    error(state, message){
        Vue.$toast.error(message)
    },
    info(state, message){
        Vue.$toast.info(message)
    },
    warning(state, message){
        Vue.$toast.warning(message)
    },
    default(state, message){
        Vue.$toast.default(message)
    }
}

export const actions = {
    success({ commit }, message) {
        commit('success', message);
    },
    error({ commit }, message) {
        commit('error', message);
    },
    info({ commit }, message) {
        commit('info', message);
    },
    warning({ commit }, message) {
        commit('warning', message);
    } ,
    default({ commit }, message) {
        commit('default', message);
    }
};